// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Suppress NextPage.min.css arrow on buttons ────────────────────────── */
.btn::after { content: '' !important; display: none !important; }

/* ── Dialog structure ───────────────────────────────────────────────────── */

mat-dialog-content {
  min-width: 600px;
  min-height: 200px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
  overflow: hidden !important;
  max-height: unset !important;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.button-gap {
  gap: 8px;
}

/* ── Utility ────────────────────────────────────────────────────────────── */
.w-100 { width: 100%; }
.bg-white { background-color: #ffffff; }
.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

/* ── Builder sizing ─────────────────────────────────────────────────────── */
.builder-field-select { min-width: 150px; max-width: 190px;}
.builder-op-select    { min-width: 160px; max-width: 220px; }
.builder-val          { min-width: 120px; max-width: 200px; }
.builder-val-sm       { min-width:  80px; max-width: 120px; }

/* ── Chips ──────────────────────────────────────────────────────────────── */
.filter-chip {
  font-size: 12px;
  padding: 4px 8px;
  white-space: nowrap;
  cursor: default;
}
.chip-remove {
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  opacity: .75;
}
.chip-remove:hover { opacity: 1; }




/* ── Autocomplete ───────────────────────────────────────────────────────── */
.autocomplete-wrapper { position: relative; display: inline-flex; }
.suggestions-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1050;
  background: #fff;
  border: 1px solid #ced4da;
  min-width: 200px;
  max-height: 200px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
  box-shadow: 0 3px 8px rgba(0,0,0,.15);
}
.suggestions-dropdown li {
  padding: 5px 10px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}
.suggestions-dropdown li:hover { background: #e9f5fb; }

/* ── Results grid ───────────────────────────────────────────────────────── */
.results-wrapper {
  overflow-x: auto;
  overflow-y: auto;
  /* ~5 rows visible: 36px row height + 1px border = 37px × 5 + thead 37px */
  max-height: calc(40px * 5 + 37px);
  border: 1px solid #dee2e6;
  font-size: 12px;
}
.results-wrapper table {
  white-space: nowrap;
  margin-bottom: 0;
  border-collapse: collapse;
}

/* Body rows: horizontal separator + right column border for distinction */
.results-wrapper tbody td {
  border-top: 1px solid #dee2e6 !important;
  border-left: none !important;
  border-right: 1px solid #dee2e6 !important;
  padding: 6px 12px;
  height: 36px;
}
.results-wrapper tbody td:last-child {
  border-right: none !important;
}
.results-wrapper tbody tr:first-child td {
  border-top: none !important;
}

/* ── Header — match data-grid blue ─────────────────────────────────────── */
.results-wrapper thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #0066B2 !important;
  color: #ffffff !important;
  font-weight: 600;
  border-top: none !important;
  border-bottom: none !important;
  border-left: none !important;
  border-right: 1px solid rgba(255,255,255,0.25) !important;
  padding: 8px 12px;
  height: 36px;
}
.results-wrapper thead th:last-child {
  border-right: none !important;
}

/* ── Sort ───────────────────────────────────────────────────────────────── */
.sort-col { cursor: pointer; -webkit-user-select: none; user-select: none; white-space: nowrap; }
.sort-col:hover { background-color: #005096 !important; }
.sort-ind { font-size: 10px; opacity: .85; margin-left: 2px; }
.result-row { cursor: pointer; }
.result-row:hover td { background-color: #e8f4fb !important; }

/* ── Status dot ─────────────────────────────────────────────────────────── */
.status-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}
.status-completed    { background: #9e9e9e; }
.status-draft        { background: #1a237e; }
.status-ongoing-lab  { background: #ffc107; }
.status-finished-lab { background: #43a047; }
.status-sent-lab     { background: #00acc1; }
.status-hold         { background: #f57c00; }
.status-ongoing      { background: #ffb300; }
.status-unknown      { background: #bdbdbd; }

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/tools/search/search.component.css"],"names":[],"mappings":"AAAA,6EAA6E;AAC7E,cAAc,sBAAsB,EAAE,wBAAwB,EAAE;;AAEhE,8EAA8E;;AAE9E;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;AACV;;AAEA,8EAA8E;AAC9E,SAAS,WAAW,EAAE;AACtB,YAAY,yBAAyB,EAAE;AACvC;EACE,mDAAmD;AACrD;;AAEA,8EAA8E;AAC9E,wBAAwB,gBAAgB,EAAE,gBAAgB,CAAC;AAC3D,wBAAwB,gBAAgB,EAAE,gBAAgB,EAAE;AAC5D,wBAAwB,gBAAgB,EAAE,gBAAgB,EAAE;AAC5D,wBAAwB,gBAAgB,EAAE,gBAAgB,EAAE;;AAE5D,8EAA8E;AAC9E;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA,qBAAqB,UAAU,EAAE;;;;;AAKjC,8EAA8E;AAC9E,wBAAwB,kBAAkB,EAAE,oBAAoB,EAAE;AAClE;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA,iCAAiC,mBAAmB,EAAE;;AAEtD,8EAA8E;AAC9E;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0EAA0E;EAC1E,iCAAiC;EACjC,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,0EAA0E;AAC1E;EACE,wCAAwC;EACxC,4BAA4B;EAC5B,0CAA0C;EAC1C,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;;AAEA,6EAA6E;AAC7E;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,yDAAyD;EACzD,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;;AAEA,8EAA8E;AAC9E,YAAY,eAAe,EAAE,yBAAiB,EAAjB,iBAAiB,EAAE,mBAAmB,EAAE;AACrE,kBAAkB,oCAAoC,EAAE;AACxD,YAAY,eAAe,EAAE,YAAY,EAAE,gBAAgB,EAAE;AAC7D,cAAc,eAAe,EAAE;AAC/B,uBAAuB,oCAAoC,EAAE;;AAE7D,8EAA8E;AAC9E;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE","sourcesContent":["/* ── Suppress NextPage.min.css arrow on buttons ────────────────────────── */\n.btn::after { content: '' !important; display: none !important; }\n\n/* ── Dialog structure ───────────────────────────────────────────────────── */\n\nmat-dialog-content {\n  min-width: 600px;\n  min-height: 200px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n  overflow: hidden !important;\n  max-height: unset !important;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.button-gap {\n  gap: 8px;\n}\n\n/* ── Utility ────────────────────────────────────────────────────────────── */\n.w-100 { width: 100%; }\n.bg-white { background-color: #ffffff; }\n.shadow-sm {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n}\n\n/* ── Builder sizing ─────────────────────────────────────────────────────── */\n.builder-field-select { min-width: 150px; max-width: 190px;}\n.builder-op-select    { min-width: 160px; max-width: 220px; }\n.builder-val          { min-width: 120px; max-width: 200px; }\n.builder-val-sm       { min-width:  80px; max-width: 120px; }\n\n/* ── Chips ──────────────────────────────────────────────────────────────── */\n.filter-chip {\n  font-size: 12px;\n  padding: 4px 8px;\n  white-space: nowrap;\n  cursor: default;\n}\n.chip-remove {\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 1;\n  opacity: .75;\n}\n.chip-remove:hover { opacity: 1; }\n\n\n\n\n/* ── Autocomplete ───────────────────────────────────────────────────────── */\n.autocomplete-wrapper { position: relative; display: inline-flex; }\n.suggestions-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1050;\n  background: #fff;\n  border: 1px solid #ced4da;\n  min-width: 200px;\n  max-height: 200px;\n  overflow-y: auto;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  box-shadow: 0 3px 8px rgba(0,0,0,.15);\n}\n.suggestions-dropdown li {\n  padding: 5px 10px;\n  font-size: 12px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.suggestions-dropdown li:hover { background: #e9f5fb; }\n\n/* ── Results grid ───────────────────────────────────────────────────────── */\n.results-wrapper {\n  overflow-x: auto;\n  overflow-y: auto;\n  /* ~5 rows visible: 36px row height + 1px border = 37px × 5 + thead 37px */\n  max-height: calc(40px * 5 + 37px);\n  border: 1px solid #dee2e6;\n  font-size: 12px;\n}\n.results-wrapper table {\n  white-space: nowrap;\n  margin-bottom: 0;\n  border-collapse: collapse;\n}\n\n/* Body rows: horizontal separator + right column border for distinction */\n.results-wrapper tbody td {\n  border-top: 1px solid #dee2e6 !important;\n  border-left: none !important;\n  border-right: 1px solid #dee2e6 !important;\n  padding: 6px 12px;\n  height: 36px;\n}\n.results-wrapper tbody td:last-child {\n  border-right: none !important;\n}\n.results-wrapper tbody tr:first-child td {\n  border-top: none !important;\n}\n\n/* ── Header — match data-grid blue ─────────────────────────────────────── */\n.results-wrapper thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background-color: #0066B2 !important;\n  color: #ffffff !important;\n  font-weight: 600;\n  border-top: none !important;\n  border-bottom: none !important;\n  border-left: none !important;\n  border-right: 1px solid rgba(255,255,255,0.25) !important;\n  padding: 8px 12px;\n  height: 36px;\n}\n.results-wrapper thead th:last-child {\n  border-right: none !important;\n}\n\n/* ── Sort ───────────────────────────────────────────────────────────────── */\n.sort-col { cursor: pointer; user-select: none; white-space: nowrap; }\n.sort-col:hover { background-color: #005096 !important; }\n.sort-ind { font-size: 10px; opacity: .85; margin-left: 2px; }\n.result-row { cursor: pointer; }\n.result-row:hover td { background-color: #e8f4fb !important; }\n\n/* ── Status dot ─────────────────────────────────────────────────────────── */\n.status-dot {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.status-completed    { background: #9e9e9e; }\n.status-draft        { background: #1a237e; }\n.status-ongoing-lab  { background: #ffc107; }\n.status-finished-lab { background: #43a047; }\n.status-sent-lab     { background: #00acc1; }\n.status-hold         { background: #f57c00; }\n.status-ongoing      { background: #ffb300; }\n.status-unknown      { background: #bdbdbd; }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
